export const accordion = () => {
  const accordionToggles = document.querySelectorAll('.wp-block-accordion__toggle');

  accordionToggles.forEach((toggle) => {
    toggle.addEventListener('click', function () {
      this.classList.toggle('active');
    });
  });

  // Open the first accordion by default, except those marked to stay closed.
  const firstAccordion = document.querySelector('.wp-block-accordion__toggle:not([data-no-auto-open])');
  if (firstAccordion) {
    firstAccordion.classList.add('active');
  }
};
